import { render, staticRenderFns } from "./AtmosCaseStudy.vue?vue&type=template&id=0867daba&scoped=true"
import script from "./AtmosCaseStudy.vue?vue&type=script&lang=js"
export * from "./AtmosCaseStudy.vue?vue&type=script&lang=js"
import style0 from "./AtmosCaseStudy.vue?vue&type=style&index=0&id=0867daba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0867daba",
  null
  
)

export default component.exports